export const UserLogsData = {
    GET_USERACTIVITYLOGS: "GET_USERACTIVITYLOGS",
}
